/**
 * Antifraud frontend API
 * Antifraud frontend API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum EntityType {
    ACCOUNT = 'ACCOUNT',
    ACCOUNT_CARD = 'ACCOUNT_CARD',
    CONTACT_DETAILS = 'CONTACT_DETAILS',
    FOREIGN_ACCOUNT = 'FOREIGN_ACCOUNT',
    FRAUD_REPORT = 'FRAUD_REPORT',
    INCIDENT = 'INCIDENT',
    LOAN = 'LOAN',
    MERCHANT = 'MERCHANT',
    MSISDN_FRAUD_ENTRY = 'MSISDN_FRAUD_ENTRY',
    OLD_LOAN = 'OLD_LOAN',
    ORGANIZATION = 'ORGANIZATION',
    PARTICIPANT = 'PARTICIPANT',
    PAYMENT_POINT = 'PAYMENT_POINT',
    PHONE_NUMBER = 'PHONE_NUMBER',
    REFUND = 'REFUND',
    RELATED_ORGANIZATION = 'RELATED_ORGANIZATION',
    RESOLUTION = 'RESOLUTION',
    SUBJECT = 'SUBJECT',
    SUBJECT_ACCOUNT = 'SUBJECT_ACCOUNT',
    SUBJECT_CATEGORY = 'SUBJECT_CATEGORY',
    SUBJECT_FOREIGN_ACCOUNT = 'SUBJECT_FOREIGN_ACCOUNT',
    TRANSACTION = 'TRANSACTION',
    TREND = 'TREND',
    TREND_FEEDBACK = 'TREND_FEEDBACK',
    TREND_STATISTIC = 'TREND_STATISTIC',
    WALLET = 'WALLET'
}

